// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__2AfMP","icon":"style_icon__3Eax-","email":"style_email__-q9HT"};